import { ISectionedHeaderProps } from "./SectionedHeader";

export const View = (props: ISectionedHeaderProps) => {
  return (
    <div
      className={
        (props.hasBorder ? "has-border" + " " : "") +
        props.className +
        " " +
        "section-header"
      }
    >
      <div className="main-head">{props.mainHead}</div>
      <div className="sub-head">{props.subHead}</div>
    </div>
  );
};
